<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">
        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Procurement</v-toolbar-title>
            <v-toolbar-title v-else>Edit Procurement - {{selectedItem.purchase_order.purchase_orders_number}}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTab"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <v-tab>PROCUREMENT PROCESS</v-tab>
                <v-tab :disabled="tabsDisabled">PROCUREMENT POSITIONS</v-tab>
                <v-tab :disabled="tabsDisabled">SUPPLIER ORDERS</v-tab>
            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTab"
                      :touchless="touchless"
        >
            <v-tab-item>

                <v-layout wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">{{cardTitle}} Procurement
                                        <v-spacer></v-spacer>
                                        <v-autocomplete v-show="!getInitialLoading"
                                                        v-if="selectedItem.id > 0"
                                                        class="statusSelecter"
                                                        :items="statuses"
                                                        item-text="name"
                                                        item-value="id"
                                                        label="Procurement Status"
                                                        v-model="selectedItem.procurements_status_id"
                                                        required
                                        ></v-autocomplete>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Customer</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            :items="getCustomers"
                                                            label="Customer"
                                                            :search-input.sync="searchCustomer"
                                                            v-model="selectedItem.purchase_order.customers_id"
                                                            :loading="loading"
                                                            hide-details
                                                            item-value="id"
                                                            item-text="name"
                                                            readonly
                                            >
                                            </v-autocomplete>

                                        </v-flex>
                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            readonly
                                                            :items="getCustomerBranchOffices"
                                                            label="Branch Office"
                                                            :search-input.sync="searchCustomerBranchOffice"
                                                            v-model="selectedItem.purchase_order.customers_branch_offices_id"
                                                            :loading="loading"
                                                            hide-details
                                                            item-value="id"
                                                            item-text="name"
                                            >
                                            </v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete
                                                    readonly v-show="!getInitialLoading"
                                                    :items="getCustomerBranchOfficesContacts"
                                                    label="Contact Person"
                                                    :search-input.sync="searchCustomerBranchOfficeContact"
                                                    v-model="selectedItem.purchase_order.customers_branch_offices_contacts_id"
                                                    :loading="loading"
                                                    :filter="customContactFilter"
                                                    hide-details
                                                    item-value="id"
                                                    item-text="name"
                                            >

                                                <template slot="selection" slot-scope="data">
                                                    {{ data.item.title }} {{ data.item.firstname }} {{
                                                    data.item.lastname }}
                                                </template>

                                                <template slot="item" slot-scope="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title
                                                        >
                                                            {{ data.item.title }} {{ data.item.firstname }} {{
                                                            data.item.lastname }}
                                                        </v-list-tile-title>
                                                        <!-- <v-list-tile-sub-title>
                                                             {{ data.item.email }}
                                                         </v-list-tile-sub-title>-->
                                                    </v-list-tile-content>
                                                </template>
                                            </v-autocomplete>
                                        </v-flex>

                                        <ProcessHistory
                                                :historyTypeID="selectedItem.histories_types_id"
                                                :itemID="selectedItem.id"
                                                :selectedItem="selectedItemForHistory"
                                        ></ProcessHistory>

                                    </v-card-title>

                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer></v-spacer>
                                            <v-btn :loading="saveProcess" dark color="secondary" @click.native="saveAndGoToNextTab(1)">
                                                Save
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                            <v-layout mt-5 row justify-end>
                            </v-layout>
                        </v-flex>

                    </v-container>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                <procurementPositions v-if="activeTab === 1"></procurementPositions>
            </v-tab-item>
            <v-tab-item>
                <SupplierOrders v-if="activeTab === 2" :procurementId="selectedItem.id"></SupplierOrders>
            </v-tab-item>
        </v-tabs-items>
    </v-card>

</template>

<script>
    import {
        Settings,
        Inquiry,
        Customer,
        CustomerBranchOffice,
        CustomerBranchOfficeContact,
        Offer,
        Procurement,
        ProcurementPosition,
        SupplierOrder
    } from '../../store/namespace-helper'
    import procurementPositions from '../Procurements/ProcurementPositions/ProcurementPositions.vue'
    import DatetimePicker from '../Shared/DatetimePicker.vue'
    import UploadDocumentPicker from '../Shared/UploadDocumentPicker.vue'
    import DocumentTokenChip from '../Shared/DocumentTokenChip.vue'
    import FakeItem from '../Shared/FakeItem.vue'
    import FakeTable from '../Shared/FakeTable.vue'
    import ProcessHistory from '../Shared/ProcessHistory.vue'
    import SupplierOrders from '../SupplierOrders/SupplierOrders.vue'

    import {dateFunctionFilters} from '../../mixins/dateFunctionFilters'
    import {initialLoadingMixin} from '../../mixins/initialLoadingMixin'

    import _ from 'lodash'

    export default {
      components: {
        procurementPositions,
        DatetimePicker,
        UploadDocumentPicker,
        DocumentTokenChip,
        FakeItem,
        FakeTable,
        ProcessHistory,
        SupplierOrders
      },
      name: 'add-procurement',
      mixins: [dateFunctionFilters, initialLoadingMixin],
      data () {
        return {
          activeTab: 0,
          headers: [
                    {text: 'Offer-ID', value: 'id'},
                    {text: 'Offer Number', value: 'offer_number'},
                    {text: 'Account', value: 'accounts_id'},
                    {text: 'Status', value: 'customers_offers_status_id'},
                    {text: 'Valid Until', value: 'valid_until'}
          ],
          countries: this.$store.getters.countries,
          selectedOffers: [],
          selectedOfferIDs: [],
          pagination: {'sortBy': 'id', 'descending': true},
          search: '',
          total: 0,
          rowsPageItems: [5, 10, 25, 50, 100, 250],
          customContactFilter (item, queryText, itemText) {
            const isMatch = (test, query) => {
              return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
            }
            const query = queryText || ''
            const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
            const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
            console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
            return rc
          },
          isVisible: false,
          supplierContact: {},
          supplierUpdated: 0,
          onDismissed: false,
          sheet: false,
          searchCustomer: '',
          searchCustomerBranchOffice: '',
          searchCustomerBranchOfficeContact: '',
          valid_until: '',
          statuses: [],
          allAccounts: [],
          touchless: true,
          uploadedDocument: null,
          selectedItemForHistory: null,
          saveProcess: false
        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
/*              this.loadCurrencies()
              this.loadTermsOfDeliveries()
              this.loadTermsOfPayments() */
              this.loadStatuses()
      /*        this.loadAllAccounts() */
              this.loadSelectedItemForHistory()
              this.initialLoadingTimeout(850)
            } else {
              this.supplierUpdated = 0
              this.resetInitialLoadingState()
            }
          }
        },
        closeDialog () {
          this.$store.dispatch(Procurement.actions.openCloseDialog)
          this.$store.dispatch(ProcurementPosition.actions.resetState)
          this.$store.dispatch(SupplierOrder.actions.resetState)

          this.activeTab = 0
        },
        loadCustomers () {
          const query = {
            search: this.searchCustomer ? this.searchCustomer : ''
          }
          this.$store.dispatch(Customer.actions.loadCustomers, query)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadCustomers()
        }, 450),
        loadCustomerBranchOffices () {
          this.$store.dispatch(CustomerBranchOffice.actions.loadCustomerBranchOffices, this.selectedItem.purchase_order.customers_id)
        },
        throttledLoadUnconfirmedOffers: _.debounce(function () {
          this.loadUnconfirmedOffers()
        }, 450),
        loadCustomerBranchOfficesContacts () {
          this.$store.dispatch(CustomerBranchOfficeContact.actions.loadContactPersons, this.selectedItem.purchase_order.customers_branch_offices_id)
        },
        loadCurrencies () {
          this.$store.dispatch(Settings.actions.loadAllCurrencies)
        },
        loadTermsOfPayments () {
          this.$store.dispatch(Settings.actions.loadTermsOfPayments)
        },
        loadTermsOfDeliveries () {
          this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
        },
        loadStatuses () {
          this.$store.dispatch(Procurement.actions.loadStatuses).then(response => {
            this.statuses = response.data.data
          })
        },
        loadSelectedItemForHistory () {
          this.$store.dispatch(Procurement.actions.loadProcurement, this.selectedItem).then(response => {
            this.selectedItemForHistory = response.data.data
          })
        },
        loadAllAccounts () {
          this.$store.dispatch(Settings.actions.loadAllAccounts).then(response => {
            this.allAccounts = response.data.data
          })
        },
        saveAndGoToNextTab (index) {
          this.saveProcess = true
          var procurement = {
            id: this.selectedItem.id,
            procurements_status_id: this.selectedItem.procurements_status_id
          }
          this.$store.dispatch(Procurement.actions.saveProcurement, procurement).then(response => {
            // this.activeTab = index
            this.loadSelectedItemForHistory()
            this.saveProcess = false
          })
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        }
      },
      computed: {
        dialog () {
          return this.$store.getters[Inquiry.getters.getOpenInquiryDialogState]
        },
        selectedItem () {
          console.log('selected procurement process: ' + JSON.stringify(this.$store.getters[Procurement.getters.getSelectedProcurement]))
          return this.$store.getters[Procurement.getters.getSelectedProcurement]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        getCustomers () {
          return this.$store.getters[Customer.getters.customers]
        },
        getCustomerBranchOffices () {
          return this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices]
        },
        getCustomerBranchOfficesContacts () {
          return this.$store.getters[CustomerBranchOfficeContact.getters.getContactPersons]
        },
        getCurrencies () {
          return this.$store.getters[Settings.getters.getAllCurrencies]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        tabsDisabled () {
          return this.$store.getters[Procurement.getters.getSelectedProcurement].id === 0
        },
        cardTitle () {
          if (this.selectedItem.id === 0) {
            return 'Add new'
          } else {
            return 'Dashboard'
          }
        },
        unconfirmedOffers () {
          this.total = this.$store.getters[Offer.getters.unconfirmedOffers].total
          return this.$store.getters[Offer.getters.unconfirmedOffers].data
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadUnconfirmedOffers()
          },
          deep: true
        },
        uploadedDocument: {
          handler (val) {
            this.selectedItem.documents_id = val.id
            console.log('uploadedDocuments id: ' + JSON.stringify(val))
          },
          deep: true
        },
        selectedOffers: {
          handler (val) {
            this.selectedOfferIDs = val.map(a => a.id)
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadUnconfirmedOffers()
          },
          deep: true
        },
        searchCustomer: {
          handler (val) {
            console.log('searchCustomer data changed: ' + JSON.stringify(val))
            this.throttledLoadItems()
          },
          deep: true

        },
        'selectedItem.purchase_order.customers_id': {
          handler (val) {
            console.log('selectedCustomer data changed: ' + JSON.stringify(val))
            this.loadCustomerBranchOffices()
          },
          deep: true

        },
        'selectedItem.purchase_order.customers_branch_offices_id': {
          handler (val) {
            console.log('selectedCustomerBranchOffice data changed: ' + JSON.stringify(val))
            this.loadCustomerBranchOfficesContacts()
          },
          deep: true

        }
      }

    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .statusSelecter {
        width: 80px;
    }

    .process-history {
        text-align: right;
        width: 100%;
        font-size: 0.95rem;
    }

</style>


// WEBPACK FOOTER //
// src/components/Shared/AddProcurement.vue